import { Box, Grid } from '@mui/material';
import React from 'react';

const LegendTemperatureComponent = () => {
  return (
    <Box
      component='div'
      sx={{
        //width: 300,
        width: '100%',
        minWidth: 250,
        maxWidth: 300,
        height: 20,
        borderRadius: 10,
        background: `linear-gradient(to right, 
                #8fcfd2,
                #77ccd4,
                #63b4bf,
                #63a3bf,
                #5da37d,
                #63a86e,
                #4c9e4c,
                #578d38,
                #678d38,
                #718d38,
                #BFC048,
                #D0CD1F,
                #ede909,
                #edcf09,
                #eda509,
                #ed8609,
                #ef760f,
                #DE4F0B,
                #EA0202,
                #C50404
    )`,
      }}
    >
      <Grid container >
        <Grid item xs={1.6}>
          <Box component='span' sx={{ color: 'white', fontSize: 10, pl: 0.5 }}>
            °C
          </Box>
        </Grid>
        <Grid item xs={1.7}>
          <Box component='span' sx={{ color: 'white', fontSize: 10 }}>
            -10
          </Box>
        </Grid>
        <Grid item xs={1.7}>
          <Box component='span' sx={{ color: 'white', fontSize: 10 }}>
            0
          </Box>
        </Grid>
        <Grid item xs={1.7}>
          <Box component='span' sx={{ color: 'white', fontSize: 10 }}>
            10
          </Box>
        </Grid>

        <Grid item xs={1.7}>
          <Box component='span' sx={{ color: 'white', fontSize: 10 }}>
            20
          </Box>
        </Grid>
        <Grid item xs={1.7}>
          <Box component='span' sx={{ color: 'white', fontSize: 10 }}>
            30
          </Box>
        </Grid>
        <Grid item xs={1.7}>
          <Box component='span' sx={{ color: 'white', fontSize: 10 }}>
            40
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LegendTemperatureComponent;
